import { useValidateListOrder } from '../../filter';
import { useWorkspaceListOrder } from './useWorkspaceListOrder';
import { useSetWorkspaceListOrder } from './useSetWorkspaceListOrder';

export const useValidateWorkspaceListOrder = () => {
  return useValidateListOrder(useWorkspaceListOrder, useSetWorkspaceListOrder);
};
